'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dEither from "./scala.util.-Either.js";
var $p;
/** @constructor */
function $c_s_util_Left(value) {
  this.gp = null;
  this.gp = value;
}
export { $c_s_util_Left as $c_s_util_Left };
$p = $c_s_util_Left.prototype = new $j_scala$002eutil$002e$002dEither.$h_s_util_Either();
$p.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
}
export { $h_s_util_Left as $h_s_util_Left };
$h_s_util_Left.prototype = $p;
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 877209692, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_s_util_Left) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.gp, x$0.gp)));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 1;
});
$p.o = (function() {
  return "Left";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.gp;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g9)));
}
export { $isArrayOf_s_util_Left as $isArrayOf_s_util_Left };
var $d_s_util_Left = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_Left, "scala.util.Left", ({
  g9: 1,
  cH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_s_util_Left as $d_s_util_Left };
